import { apiClient } from './client';

export interface Flag {
  flagId: string;
  projectId: string;
  key: string;
  name: string;
  dependencies: string[];
  userDisplayMessage: string;
  masterActive: boolean;
  environments: Record<string, boolean>;
  createdAt: string;
  updatedAt: string;
}

export const flagsApi = {
  list: (projectId: string) =>
    apiClient.get<Flag[]>(`/projects/${projectId}/flags`).then(r => r.data),
  create: (projectId: string, data: Partial<Flag>) =>
    apiClient.post<Flag>(`/projects/${projectId}/flags`, data).then(r => r.data),
  update: (flagId: string, data: Partial<Flag>) =>
    apiClient.put<Flag>(`/flags/${flagId}`, data).then(r => r.data),
  delete: (flagId: string) => apiClient.delete(`/flags/${flagId}`),
};
